import { useEffect, useState } from 'react'

import useApiGet from 'Pods/Shared/Hooks/useApiGet'
import { isEditScreenRun } from 'Pods/ThreeDStudio/Shared/Utils/imageRun'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const isStyle = asset => asset.source === 'style_template'

// Every image the run was made from: the uploaded images (a 2D render's viewer capture
// among them) first, then the styles. An edit's inputs are the version it edited (and
// the painted mask), so an edit has none.
const toReferences = (run) => {
  if (!run || isEditScreenRun(run)) return EMPTY_ARRAY

  const images = (run.inputAssets ?? []).filter(asset => asset.assetType === 'image' && asset.fileUrl)
  const references = [...images.filter(asset => !isStyle(asset)), ...images.filter(isStyle)]
    .map(asset => ({ id: asset.assetId, url: asset.fileUrl, isStyle: isStyle(asset) }))

  return references.length > 0 ? references : EMPTY_ARRAY
}

// The images the run behind the opened image was generated from. The runs endpoint only
// serves the viewer's own runs, and the editor gets no run id for anyone else's image, so
// another user's uploads are never shown.
function useRunReferences(runId) {
  const { getData } = useApiGet()
  const [loaded, setLoaded] = useState(null)

  useEffect(() => {
    if (runId == null) return

    getData({
      path: `/api/internal/generator/runs/${runId}`,
      onSuccess: (response) => {
        setLoaded({ runId, references: toReferences(response?.data?.data?.attributes) })
      },
    })
  }, [getData, runId])

  // Keyed on the run so a previous image's references never show for the next one.
  return loaded?.runId === runId ? loaded.references : EMPTY_ARRAY
}

export default useRunReferences
